import React, { useState, useEffect, useRef } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import {
    Box,
    Button,
    Drawer,
    DrawerBody,
    DrawerCloseButton,
    DrawerContent,
    DrawerOverlay,
    Flex,
    Stack,
    Text,
    useColorModeValue,
    useDisclosure
} from '@chakra-ui/react';
import { header } from 'routes.js';

// Components
import IconBox from 'components/Icons/IconBox';
import { ReactComponent as HamburgerIcon } from 'assets/svg/hamburger.svg';
import {
  ArrowNavbarIcon,
  NotificationIcon,
  LoginIcon
} from 'components/Icons/Icons';
import SwitchTheme from './SwitchTheme';

function NavbarResponsive(props) {
    let location = useLocation();
    const [state, setState] = React.useState({});
    const mainPanel = React.useRef();
    const bgBlurColor = useColorModeValue('rgba(255, 255, 255, 0.30)', 'rgba(0, 0, 0, 0.30)');
    const bgColor = useColorModeValue('#E0EAFF', '#050A19');
    const dividerColor = useColorModeValue('#CBE7FF', '#262D47');
  
    const btnRef = React.useRef();

    const textColor = useColorModeValue('#0E1633', 'white');
    const textActiveColor = useColorModeValue('gray.75', '#0497FD');

    const [openDropdown, setOpenDropdown] = useState(null);

    const handleDropdownToggle = (index) => {
      setOpenDropdown(openDropdown === index ? null : index);
    };
  
    const createLinks = () => {
      return (header.map((item, index) => {
        const isDropdown = !!item.views;
        const isActive = location.pathname.includes(item.path);

        return isDropdown ? (
          <Box key={index} p="14px 0 0px 4px" >
            <Flex
              pb={isDropdown ? '14px' : '0'}
              onClick={() => handleDropdownToggle(index)}
              color={openDropdown === index ? {textActiveColor} : {textColor}}
            >
              <Text display="inline-block" fontWeight="500" color={openDropdown === index ? {textActiveColor} : {textColor}}>{item.name}</Text>
              <ArrowNavbarIcon mt={{base: '2px', lg: '0px'}}  color={openDropdown === index ? {textActiveColor} : {textColor}} fontSize="16px" transform={openDropdown === index ? 'rotate(180deg)' : 'rotate(0deg)'} ml="4px" />
            </Flex>
            <Box display={openDropdown === index ? 'block' : 'none'}>
              {item.views.map((subItem, subIndex) => (
                <Flex key={index} m="0px 12px 0 16px" p="14px 0 14px 8px" onClick={() => props.setIsOpenMenu(!props.isOpenMenu)}>
                  {subItem.external ? (
                    <a href={subItem.external} style={{ width: '100%', display: 'flex', letterSpacing: '-0.4px' }}>
                      {subItem.name}
                    </a>
                  ) : (
                    <NavLink to={`${subItem.layout}${subItem.path}`} style={{ width: '100%', display: 'flex', letterSpacing: '-0.4px' }} activeClassName="active">
                      {subItem.name}
                    </NavLink>
                  )}
                </Flex>
              ))}
            </Box>
          </Box>
        ) : (
          <Flex key={index} p="14px 0 14px 4px" onClick={() => props.setIsOpenMenu(!props.isOpenMenu)}>
            <Link 
              as={NavLink} 
              to={`${item.layout}${item.path}`} 
              mr="12px" 
              style={{
                color: isActive ? textActiveColor : textColor,
                fontWeight: 500,
                letterSpacing: '-0.4px !important'
              }}
            >
              {item.name}
            </Link>
          </Flex>
        );
      }));
    };

    return (
      <Box
        display={{ sm: 'flex', xl: 'none' }}
        ref={mainPanel}>
        <Box 
          display={props.isOpenMenu ? 'block' : 'none'}
          position="fixed"
          top="0px"
          left="0px"
          placement={'top'}
          finalFocusRef={btnRef}
          bg={bgBlurColor}
          h="100vh"
          width="100%"
          zIndex="998"
          backdropFilter="blur(6px)">
          <Box bg={bgColor} p="100px 16px 24px 16px">
            <Box bg={dividerColor} w="100%" h="1px" mb="12px" />
            {createLinks()}
            <Flex p="14px 0 14px 4px">
              <a 
                href={'https://www.lmctplus.store'} 
                target="_blank"
                style={{
                  color: textColor,
                  fontWeight: 500,
                  letterSpacing: '-0.4px !important'
                }}
              >
                Shop
              </a>
            </Flex>

            <Box mt="8px" display={{ base: 'block', md: 'none'}}>
              <Box bg={dividerColor} w="100%" h="1px" mb="12px" />
              <Flex w="100%" justifyContent="space-between" alignItems="center">
                <Text pl="5px" variant="title-md" fontWeight="500" color={textColor}>Night mode</Text>
                <SwitchTheme />
              </Flex>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }

  export default NavbarResponsive;